import Vue from 'vue'
import Router from 'vue-router'

// 许可证激活
const LicenseActivation = () => import(/* webpackChunkName: "licenseActivation" */ '@/views/LicenseActivation.vue');
const LicenseActive = () => import(/* webpackChunkName: "licenseActivation" */ '@/views/LicenseActive.vue');
const LicenseDeactive = () => import(/* webpackChunkName: "licenseActivation" */ '@/views/LicenseDeactive.vue');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: LicenseActivation,
      children: [
        {
          path: '/active',
          component: LicenseActive,
        },
        {
          path: '/deactive',
          component: LicenseDeactive,
        },
      ],
      redirect: '/active',
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js